import { connect } from "react-redux";

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdOutlineCasino } from 'react-icons/md';
import { PiCoinsBold } from 'react-icons/pi';
import WinningTicker from '../Home/WinningTicker';
import { SiteFeatures } from 'config/siteFeatures';
import { FaFutbol, FaHome } from 'react-icons/fa';
import { IoIosCellular } from "react-icons/io";
const BottomNavigation = (props) => {
  const { isNavVisible = true, permissions, loggedIn } = props;
  const { t } = useTranslation();

  // Permissions yoksa boş div döndür, ama bileşeni tamamen gizleme
  if (!permissions && !SiteFeatures.CLOSED_SYSTEM) {
    return (
      <div
        style={{
          zIndex: 50,
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          width: '100%',
          height: '64px'
        }}
        className="mobile-show"
      />
    );
  }

  return (
    <div
      style={{
        zIndex: 50,
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100%'
      }}
      className="mobile-show"
    >
      {/* Kazanç Ticker 
  <div style={{ position: 'fixed' ,bottom:'64px' }}>
    <WinningTicker />
  </div>
*/}
      <div
        style={{
          visibility: isNavVisible ? 'visible' : 'hidden',
          opacity: isNavVisible ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
 
        }}
        className="bg-secondary-500 tab-navigation-w-bc btm-nav border-t border-secondary-500  drop-shadow-2xl shadow-2xl "
      >
        <Link
            to={"/"}
            className="text-white max-w-[4.4rem] border-secondary-400 bg-transparent border-0 btn btn-md btn-squarebtn-transparent rounded-none hover:bg-primary-600 transition-colors duration-200"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <FaHome className="w-5 h-5" />
              <span className="btm-nav-label text-xs font-medium">
                {t("TITLE_HOME")}
              </span>
            </div>
          </Link>
        {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || permissions?.SPORTS_ACCESS?.Value) && (
           <Link
            to={"/sports/live"}
            style={{ backgroundColor: 'transparent !important' }}
            className="text-white max-w-[5rem] border-secondary-400 bg-transparent border-0 btn  btn-md btn-square  rounded-none hover:bg-primary-600 transition-colors duration-200 btn-transparent"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <IoIosCellular className="w-5 h-5 text-red-500" />
              <span className="btm-nav-label text-xs font-medium text-red-500">
                {t("TITLE_LIVE")}
              </span>
            </div>
          </Link>
        )}
        {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || permissions?.SPORTS_ACCESS?.Value) && (
             <Link
            to={"/sports"}
            style={{ backgroundColor: 'transparent !important' }}
            className="text-white max-w-[5rem] border-secondary-400 bg-transparent border-0 btn  btn-md btn-square  rounded-none hover:bg-primary-600 transition-colors duration-200 btn-transparent"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <FaFutbol className="w-5 h-5" />
              <span className="btm-nav-label text-xs font-medium">
                {t("TITLE_SPORTS")}
              </span>
            </div>
          </Link>
        )}


 
        {((!SiteFeatures.CLOSED_SYSTEM && !props.loggedIn) || permissions?.SPORTS_ACCESS?.Value) && (
          <Link
            to={"/my-account/coupons/"}
            className="text-white max-w-[4.4rem] border-secondary-400 bg-transparent border-0 btn btn-md btn-square btn-transparent rounded-none hover:bg-primary-600 transition-colors duration-200"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                />
              </svg>
              <span className="btm-nav-label text-xs font-medium">
                {t("NAV_TITLE_COUPONS")}
              </span>
            </div>
          </Link>
        )}



        {
          props.loggedIn &&
          <Link
            to={"/my-account/profile/"}
            style={{ backgroundColor: 'transparent !important' }}
            className="text-white max-w-[5rem] bg-transparent border-0 btn btn-md btn-square btn-transparent  rounded-none hover:bg-primary-600 transition-colors duration-200"
          >
            <div className="flex flex-col justify-center items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"
                />
              </svg>
              <span className="btm-nav-label text-xs font-medium">
                {t("TITLE_MYACCOUNT")}
              </span>
            </div>
          </Link>
        }
      </div>
    </div>
  );
};


const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, permissions } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    permissions,
  };
};

export default connect(mapStateToProps)(BottomNavigation);
